module.exports = "/assets/85f16fb0aefee3547f3d8df494097db7.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/JZ.png
// module id = 2652
// module chunks = 0